import { useMemo } from 'react';
import { Connection } from './useConnections';

export const useConnectionTags = (connections: Connection[]) => {
  const allUniqueMatchingSubjects = useMemo(() => {
    const uniqueSubjects = new Set<string>();

    connections.forEach(connection => {
      const parentSubjectsSet = new Set(connection.parent?.subjects || []);
      const tutorSubjects = connection.tutor?.subjects || [];

      const matches = tutorSubjects.filter(subject => parentSubjectsSet.has(subject));
      matches.forEach(match => uniqueSubjects.add(match));
    });

    return uniqueSubjects;
  }, [connections]);

  const shouldRenderTags = allUniqueMatchingSubjects.size > 1;

  return { allUniqueMatchingSubjects, shouldRenderTags };
};
